export default __webpack_public_path__ + "static/media/04.0ca76f51.jpg";